var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "scaling-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "13 12 62 62",
    ref: svgRef,
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1053.216 -664.948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1053.148 664.88)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -12.93, -11.93)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    ref: "buttonSvgBack",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(13 12)",
    style: {
      fill: "rgb(42, 61, 141)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    ref: "buttonSvgFill",
    d: "M34.746,17.861A16.873,16.873,0,1,0,17.861,34.722a16.522,16.522,0,0,0,5.232-.843c.124-.025.273-.074.4-.1l9.893,2.9-1.537-9.4A16.613,16.613,0,0,0,34.746,17.861ZM26.762,28.919l-5.281-1.562a9.247,9.247,0,0,1-3.62.719,10.054,10.054,0,0,1-9.844-10.24A10.054,10.054,0,0,1,17.861,7.6,10.054,10.054,0,0,1,27.7,17.836a10.539,10.539,0,0,1-1.785,5.876Z",
    transform: "translate(13.127 12.16)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.10adde973549f86b1926a4978d3254f4.svg";
export { ForwardRef as ReactComponent };